/**
 * ``?emailIndex=`` for ``/email-viewer``. Shared by the Outlook viewer and the
 * theme archive host so a bookmarked message opens in either path.
 */

export function parseEmailIndex(raw: string | null): number | null {
  if (raw == null) return null;
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  const n = Number.parseInt(trimmed, 10);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export function writeEmailIndexToUrl(emailIndex: number | null): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (emailIndex == null) {
    url.searchParams.delete('emailIndex');
  } else {
    url.searchParams.set('emailIndex', String(emailIndex));
  }
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
}
